import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const IdeateWrapper = () => {
  useEffect(() => {
    // 尝试拦截“关于”按钮的点击
    const handleClick = e => {
      const target = e.target;
      // 检查点击元素的文本内容或属性
      // 这里假设按钮或链接包含 "About" 或 "关于"
      // 也可以检查 href 属性是否指向旧的关于链接
      if (
        (target.innerText &&
          (target.innerText.toLowerCase().includes('about') ||
            target.innerText.includes('关于'))) ||
        (target.tagName === 'A' &&
          target.getAttribute('href') &&
          target.getAttribute('href').includes('about'))
      ) {
        e.preventDefault();
        window.location.href = '/about';
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>IDEATE</title>
        <script type="module" crossOrigin="true" src="/assets/index-B0naGZJP.js"></script>
        <link rel="stylesheet" crossOrigin="true" href="/assets/index-CmKumg1q.css" />
      </Helmet>
      <div id="root"></div>
    </>
  );
};

export default IdeateWrapper;
